import { useCallback } from 'react';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';

export const useLogClickSimilarGoodsMore = () => {
  const logGoodsAnalyticsEvent = useLogGoodsAnalyticsEvent();

  return useCallback(() => {
    logGoodsAnalyticsEvent({ name: 'CLICK_SIMILAR_GOODS_MORE' });
  }, [logGoodsAnalyticsEvent]);
};
